import { useEffect, useState } from "react";
import { fetchEnrollmentsFilter } from "../../service/AdminService/enrollmentService";
import { message } from "antd";

export const useEnrollmentFilter = () => {
  const [filterLoading, setFilterLoading] = useState(false);

  const [bundleOptions, setBundleOptions] = useState([]);
  const [courseOptions, setCourseOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [groupOptions, setGroupOptions] = useState([]);

  const toOptions = (arr = []) =>
    arr.map((item) => ({ label: item, value: item }));

  const getFilters = async () => {
    setFilterLoading(true);

    const response = await fetchEnrollmentsFilter();

    if (response.success) {
      const data = response?.data;

      setBundleOptions(toOptions(data?.bundleNames));
      setCourseOptions(toOptions(data?.courseNames));
      setUserOptions(toOptions(data?.userNames));
      setGroupOptions(toOptions(data?.groupNames));
    } else {
      message.error(response.message);
    }

    setFilterLoading(false);
  };

  useEffect(() => {
    getFilters();
  }, []);

  return {
    bundleOptions,
    courseOptions,
    userOptions,
    groupOptions,
    filterLoading,
  };
};